/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiLastRunInfoType;
(function (ApiLastRunInfoType) {
    ApiLastRunInfoType["LAST_RUN_INFO_NAME_UNSPECIFIED"] = "LastRunInfoNameUnspecified";
    ApiLastRunInfoType["LAST_RUN_INFO_NAME_PAGEVIEWS"] = "LastRunInfoNamePageviews";
    ApiLastRunInfoType["LAST_RUN_INFO_NAME_GOOGLE_SYNC_UTC"] = "LastRunInfoNameGoogleSyncUTC";
    ApiLastRunInfoType["LAST_RUN_INFO_NAME_REFRESH_FACEBOOK_ENTITIES"] = "LastRunInfoNameRefreshFacebookEntities";
})(ApiLastRunInfoType || (ApiLastRunInfoType = {}));
export function ApiLastRunInfoTypeFromJSON(json) {
    return ApiLastRunInfoTypeFromJSONTyped(json, false);
}
export function ApiLastRunInfoTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiLastRunInfoTypeToJSON(value) {
    return value;
}
